import { AuthProvider, UserProvider } from '@myosh/myosh-login';
import { Toaster } from '@myosh/odin-components';
import { BrowserRouter as Router } from 'react-router';
import RoutesComponent from './components/routing/routes.component';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <UserProvider>
          <RoutesComponent />
        </UserProvider>
      </AuthProvider>
      <Toaster />
    </Router>
  );
}

export default App;
